export const REGEX_NUMBER = /^[0-9]+$/;
export const REGEX_MILITARY_TIME = /^$|([01]\d|2[0-3])([0-5]\d)$/g;
export const REGEX_HOUR_MINUTE = /(\d{2})(\d{2})/;
